import React from "react";
import { CartesianCoordinate } from "../../../Model/Coordinate";
import { EPlateCorner, EPlateCornerShorten, EPlateCornerTooltip } from "../../../Model/EPlateCorner";
import { ImagerState } from "../../../Model/ModuleState";
import { DropCalibrationPoint, PlateType } from "../../../Model/PlateType";
import ServicingTable, { ServicingTableRow } from "../../Common/ServicingTable";
import PlateCornerUtil from "./../../../Utility/PlateCornerUtil";
import "./dropPosition.css";

function getDropCalibrationRow(
  col: number,
  row: number,
  plateCorner: EPlateCorner,
  coordinate: CartesianCoordinate,
  selected: boolean
): ServicingTableRow {
  const wellName = EPlateCornerShorten[plateCorner];
  return {
    id: plateCorner,
    x: coordinate.x,
    y: coordinate.y,
    z: coordinate.z,
    name: wellName,
    selected: selected,
    tooltip: EPlateCornerTooltip[plateCorner]
  };
}

function getDropCalibrationData(
  plateType: PlateType,
  dropCalibration: DropCalibrationPoint,
  selectedPlateCorner: EPlateCorner
): ServicingTableRow[] {
  const result: ServicingTableRow[] = [
    getDropCalibrationRow(
      0,
      0,
      EPlateCorner.TopLeft,
      dropCalibration.topLeft,
      selectedPlateCorner === EPlateCorner.TopLeft
    ),
    getDropCalibrationRow(
      plateType.numberOfColumn - 1,
      0,
      EPlateCorner.TopRight,
      dropCalibration.topRight,
      selectedPlateCorner === EPlateCorner.TopRight
    ),
    getDropCalibrationRow(
      plateType.numberOfColumn - 1,
      plateType.numberOfRow - 1,
      EPlateCorner.BottomRight,
      dropCalibration.bottomRight,
      selectedPlateCorner === EPlateCorner.BottomRight
    ),
    getDropCalibrationRow(
      0,
      plateType.numberOfRow - 1,
      EPlateCorner.BottomLeft,
      dropCalibration.bottomLeft,
      selectedPlateCorner === EPlateCorner.BottomLeft
    ),
  ];
  return result;
}

type Props = {
  plateType: PlateType;
  imagerState: ImagerState;
  imagerIdentifier: string;
  plateCorner: EPlateCorner;
  setPlateCorner: (plateCorner: EPlateCorner) => void;
  dropNumber: number;
  setDropNumber: (dropNumber: number) => void;
  dropCalibration: DropCalibrationPoint;
  setDropCalibration: (dropCalibration: DropCalibrationPoint) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
};

const DropPositionTabView = ({
  imagerState,
  plateType,
  imagerIdentifier,
  plateCorner,
  setPlateCorner,
  dropNumber,
  setDropNumber,
  dropCalibration,
  setDropCalibration,
  disabled = false,
  style,
}: Props) => {
  const onRowSelected = (row: ServicingTableRow) => {
    if (row.id !== plateCorner) {
      setPlateCorner(PlateCornerUtil.toField(row.id));
    }
  };

  const dropCalibrationData = getDropCalibrationData(plateType, dropCalibration, plateCorner);

  const onRowUpdated = (row: ServicingTableRow) => {
    const dl = {
      ...dropCalibration,
      [row.id]: {
        x: row.x,
        y: row.y,
        z: row.z,
      },
    };

    setDropCalibration(dl);
  };

  return (
    <ServicingTable
      imagerIdentifier={imagerIdentifier}
      imagerState={imagerState}
      disabled={disabled}
      data={dropCalibrationData}
      onRowSelected={onRowSelected}
      dropNumber={dropNumber}
      maxDrop={plateType.numberOfDropPerWell}
      onDropNumberChanged={setDropNumber}
      onRowUpdated={onRowUpdated}
      style={style}
    />
  );
};

export default DropPositionTabView;
